import React from 'react';
import classes from '../index.module.scss';

const TYPE_LIST = {
  business_registered: 'Business Registrations',
  contracting_officer_registered: 'Government Users',
  opportunities: 'Contracting Opportunities',
  contract_opportunities: 'Micropurchases',
  future_opportunities: 'Future Opportunities',
  purchases: 'B2B Opportunities',
}

const QuickStatsTableBody = ({ list }) => {
  return (
    <>
      {
        Object.keys(list).map(item => {
          const { today, month, year, total } = list[item];

          return (
            <tr 
              key={item}
            >
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{TYPE_LIST[item]}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{today}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{month}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{year}</td>
              <td className={`${classes.Title_Normal} ${classes.Vertical_Middle}`}>{total}</td>
            </tr>
          )
        })
      }
    </>
  )
}

export default QuickStatsTableBody;